module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "basic-paragraph"
  }, [_c('span', {
    staticClass: "authorname"
  }, [_vm._v("Dedication")]), _c('span', {
    staticClass: "authorname"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "byline"
  })]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I’d like to dedicate this book to my youngest son, Jason Meyer Watkins. He lives in New York and is an editor for ")]), _c('span', {
    staticClass: "dedication2"
  }, [_vm._v("Saturday Night Live")]), _c('span', {
    staticClass: "byline"
  }, [_vm._v(". His special interest in my career has been helpful and meaningful. He encourages me to think outside the box with my endeavors. I frequently call him my hero, and he knows why. Thank you!")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Of course, my biggest fan is my husband, Keith Hazelwood. He is not only there for heavy lifting these days but is also my best promoter. Thank you, sweetie!")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I’m lucky to have family, friends, and loyal readers to give me the courage to keep on writing. Thank you all so much!")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("Ann Hazelwood")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cfa9dee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/quilt-left-behind_split2.vue
// module id = 66
// module chunks = 0